module.exports = __webpack_public_path__ + "static/media/linkedin-original.b53e8ba8.svg";